import React from 'react'
import styles from './style.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ActiveDot from '../../assets/images/icon/icongreendot.svg'
import InActiveDot from '../../assets/images/icon/iconreddot.svg'

import { faDownload, faFilter, faPencil, faTrash, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import Pagination from '../Common/Pagination/List'

const Index = ({ setShowAddModal, data, onEdit, setCurrentPage, currentPage }) => {
    console.log(data)
    const { users, total } = data
    return (
        <div className="container">
            <div className='row'>
                <div className='col-md-12'>
                    <div className={`${styles['manage-box']}`}>
                        <div className="d-flex justify-content-between align-items-center mb-3 px-3">
                            <h4 className={`${styles['user-title']}`}>Manage Users
                                <span>{total} Users</span>
                            </h4>
                            <div>
                                {/* <a href='#' className={`${styles['filter-link']} pe-3`}><FontAwesomeIcon icon={faFilter} /></a>
                                <a href='#' className={`${styles['download-link']} pe-3`}><FontAwesomeIcon icon={faDownload} /></a>
                                <a href='#' className={`${styles['delete-link']} pe-3`}><FontAwesomeIcon icon={faTrash} /></a> */}
                                <button onClick={setShowAddModal} className={`${styles['add-btn']} btn`}>+ Add User</button>

                            </div>
                        </div>
                        <div className='table-responsive'>
                            <table className="table table-striped table-responsive table-hover">
                                <thead className="table-light">
                                    <tr className={`${styles['tablectm-head']}`}>
                                        <th scope="col">Full Name</th>
                                        <th scope="col">Employee Email ID</th>
                                        <th scope="col">Phone</th>
                                        <th scope="col">Username</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Actions</th>
                                    </tr>
                                </thead>
                                <tbody className={`${styles['tablectm-text']}`}>
                                    {users?.map((user, index) => (
                                        <tr key={index}>
                                            <td>

                                                <span>{user.SUB_USER_FULL_NAME}</span>
                                            </td>
                                            <td>{user.SUB_USER_EMAIL_ID}</td>
                                            <td>+91-{user.SUB_USER_PHONE}</td>
                                            <td>{user.SUB_USER_USERNAME}</td>
                                            <td>
                                                <span className={`${styles['active-badge']}`}><img src={user.STATUS === 'A' ? ActiveDot : InActiveDot} className='pe-2' />{user.STATUS === 'A' ? 'Active' : 'Inactive'}</span>
                                            </td>
                                            <td>
                                                <a className={`${styles['link-ctm']} me-4`}>
                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                </a>
                                                <a className={`${styles['link-ctm']}`}
                                                    onClick={() => { onEdit(user) }}
                                                >
                                                    <FontAwesomeIcon icon={faPencil} />
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <Pagination
                            totalCount={total}
                            limit={10}
                            range={5}
                            currentPage={currentPage}
                            onPageChange={(page) => setCurrentPage(page)}
                        />
                    </div>


                </div>
            </div>
        </div>
    )
}

export default Index